export const iconFontAwesomeLogisticsDolly = (
	<i className="fa-solid fa-dolly"></i>
);
